var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 13.75C6.41421 13.75 6.75 14.0858 6.75 14.5V19.1893L7.96967 17.9697C8.26256 17.6768 8.73744 17.6768 9.03033 17.9697C9.32322 18.2626 9.32322 18.7374 9.03033 19.0303L6.53033 21.5303C6.23744 21.8232 5.76256 21.8232 5.46967 21.5303L2.96967 19.0303C2.67678 18.7374 2.67678 18.2626 2.96967 17.9697C3.26256 17.6768 3.73744 17.6768 4.03033 17.9697L5.25 19.1893V14.5C5.25 14.0858 5.58579 13.75 6 13.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46967 2.46967C5.76256 2.17678 6.23744 2.17678 6.53033 2.46967L9.03033 4.96967C9.32322 5.26256 9.32322 5.73744 9.03033 6.03033C8.73744 6.32322 8.26256 6.32322 7.96967 6.03033L6.75 4.81066V9.5C6.75 9.91421 6.41421 10.25 6 10.25C5.58579 10.25 5.25 9.91421 5.25 9.5V4.81066L4.03033 6.03033C3.73744 6.32322 3.26256 6.32322 2.96967 6.03033C2.67678 5.73744 2.67678 5.26256 2.96967 4.96967L5.46967 2.46967Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 10C10.75 9.58579 11.0858 9.25 11.5 9.25H18.5C18.9142 9.25 19.25 9.58579 19.25 10C19.25 10.4142 18.9142 10.75 18.5 10.75H11.5C11.0858 10.75 10.75 10.4142 10.75 10Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 14C10.75 13.5858 11.0858 13.25 11.5 13.25H15.5C15.9142 13.25 16.25 13.5858 16.25 14C16.25 14.4142 15.9142 14.75 15.5 14.75H11.5C11.0858 14.75 10.75 14.4142 10.75 14Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 18C10.75 17.5858 11.0858 17.25 11.5 17.25H13.5C13.9142 17.25 14.25 17.5858 14.25 18C14.25 18.4142 13.9142 18.75 13.5 18.75H11.5C11.0858 18.75 10.75 18.4142 10.75 18Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 6C10.75 5.58579 11.0858 5.25 11.5 5.25H20.5C20.9142 5.25 21.25 5.58579 21.25 6C21.25 6.41421 20.9142 6.75 20.5 6.75H11.5C11.0858 6.75 10.75 6.41421 10.75 6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSort);
export default __webpack_public_path__ + "static/media/ic-sort.a72c068b7b2d400309235fc1e86b5641.svg";
export { ForwardRef as ReactComponent };